import { Trans } from 'react-i18next';
import { MyLink, MyTooltip } from '@scramble/ui';
import { APP_LINKS } from '@/helpers/links';
import { LOAN_GROUPS_IDS } from '@/helpers/constants';
import IconTooltip from '@scramble/design-system/icons/help-circle.svg';

export const TERM_TOOLTIPS = t => ({
  earnings: () => (
    <MyTooltip
      renderElement={() => (
        <img src={IconTooltip} width={16} height={16} alt="tooltip" />
      )}
      renderContent={() => (
        <div className="t_earning">{t('loan_terms:tooltip_earnings')}</div>
      )}
    ></MyTooltip>
  ),
  net_annual_return: () => (
    <MyTooltip
      renderElement={() => (
        <img src={IconTooltip} width={16} height={16} alt="tooltip" />
      )}
      renderContent={() => (
        <div className="t_return">{t('loan_terms:tooltip_net_annual_return')}</div>
      )}
    />
  ),
  term: () => (
    <MyTooltip
      delay={3000}
      renderElement={() => (
        <img src={IconTooltip} width={16} height={16} alt="tooltip" />
      )}
      renderContent={() => (
        <div className="t_term">
          {t('loan_terms:tooltip_term')}{' '}
          <MyLink href={APP_LINKS.helpLoanTerms()} underline>
            {t('loan_terms:tooltip_scramble_loan_terms')}
          </MyLink>
        </div>
      )}
    />
  ),
  repayments: () => (
    <MyTooltip
      renderElement={() => (
        <img src={IconTooltip} width={16} height={16} alt="tooltip" />
      )}
      renderContent={() => (
        <div className="t_repayments" style={{ whiteSpace: 'pre-line' }}>
          <Trans
            ns="loan_terms"
            i18nKey="tooltip_repayments"
            components={{ span: <span style={{ fontWeight: '500' }} /> }}
          />
        </div>
      )}
    ></MyTooltip>
  ),
  skin: () => (
    <MyTooltip
      renderElement={() => (
        <img src={IconTooltip} width={16} height={16} alt="tooltip" />
      )}
      renderContent={() => <div className="t_skin">{t('loan_terms:tooltip_skin')}</div>}
    />
  ),
  protection: group => (
    <MyTooltip
      renderElement={() => (
        <img src={IconTooltip} width={16} height={16} alt="tooltip" />
      )}
      renderContent={() => (
        <div className="t_protection">
          {group === LOAN_GROUPS_IDS.conservative.id && (
            <ul className="scr-circle-list">
              <li>{t('loan_terms:tooltip_protection_conservative_1')}</li>
              <li>{t('loan_terms:tooltip_protection_conservative_2')}</li>
              <li>{t('loan_terms:tooltip_protection_conservative_3')}</li>
            </ul>
          )}

          {group === LOAN_GROUPS_IDS.moderate.id && (
            <ul className="scr-circle-list">
              <li>{t('loan_terms:tooltip_protection_moderate_1')}</li>
            </ul>
          )}
        </div>
      )}
    />
  ),
});
